<ct-expansion-panel [configuration]="this.panelConfiguration" *ngIf="this.panelConfiguration"></ct-expansion-panel>

<ng-template #companyInformationTemplate>

<div class="company-display-container" *ngIf="company">

  <!-- ─── Griglia unica: campi CTCompany + CompanyInformation affiancati ──── -->
  <div class="company-info-grid" *ngIf="hasDataToShow() || hasCompanyContactDataToShow()">

    <!-- Campi diretti di CTCompany (ReferenceName, FiscalCode ecc.) -->
    <div *ngFor="let field of displayFields" class="info-item">
      <span class="info-label">{{ field.label | translate }}:</span>
      <span class="info-value" [class.empty-value]="isEmpty(getFieldValue(field))">
        {{ getFieldValue(field) }}
      </span>
    </div>

    <!-- Campi CompanyInformation (Phone, Email, SDI ecc.) nella stessa griglia -->
    <div *ngFor="let field of companyContactDisplayFields" class="info-item">
      <span class="info-label">{{ field.label | translate }}:</span>
      <span class="info-value"
        [class.empty-value]="field.value === null || field.value === '' || field.value === undefined">
        {{ (field.value !== null && field.value !== '' && field.value !== undefined) ? field.value : '-' }}
      </span>
    </div>

  </div>

  <!-- Messaggio se non ci sono dati in nessuna delle due sorgenti -->
  <div *ngIf="!hasDataToShow() && !hasCompanyContactDataToShow()" class="no-data-message">
    <p>Nessuna informazione disponibile</p>
  </div>

  <!-- Sezione places (struttura diversa, rimane separata) -->
  <div *ngIf="company.Places && company.Places.length > 0 && this.companyInformationConfiguration.visibleFields.includes('Places')" class="places-section">
    <div class="places-list">
      <div *ngFor="let place of company.Places; let i = index" class="place-item">
        <span class="place-index">Indirizzo: </span>
        <span class="place-info">{{ place.FullAddressWithType || place }}</span>
      </div>
    </div>
  </div>

  <!-- ─── Sezione LeadInformation — divider + griglia separata ───────────── -->
  <ng-container *ngIf="hasLeadDataToShow()">

    <div class="lead-information-divider"></div>

    <div class="company-info-grid">
      <div *ngFor="let field of leadInformationDisplayFields" class="info-item">
        <span class="info-label">{{ field.label | translate }}:</span>
        <span class="info-value"
          [class.empty-value]="field.value === null || field.value === '' || field.value === undefined">
          {{ (field.value !== null && field.value !== '' && field.value !== undefined) ? field.value : '-' }}
        </span>
      </div>
    </div>

  </ng-container>

</div>

</ng-template>
